import { useMemo } from 'react'

export function useGraphData(data) {
  const ctrData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'ctr'), [data])
  const clicksData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'clicks'), [data])
  const impressionsData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'impressions'), [data])
  const engagementsData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'engagement'), [data])
  const conversionsData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'conversions'), [data])
  const leadData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'lead'), [data])
  const cpaData = useMemo(() => data && data.find(dataSet => dataSet.metric === 'cpa'), [data])

  return useMemo(
    () => ({
      ctrData,
      clicksData,
      impressionsData,
      engagementsData,
      conversionsData,
      leadData,
      cpaData
    }),
    [ctrData, clicksData, impressionsData, engagementsData, conversionsData, leadData, cpaData]
  )
}
